import axios, { AxiosHeaders } from 'axios';
import * as ApiConstant from './apiConstant';

type HttpParams = {
  params?: {
    sc_apikey?: string;
  };
  headers?: AxiosHeaders;
  withCredentials?: boolean;
};

export async function HttpGet(endpoint = '', params: HttpParams = {}) {
  params.params = {};
  params.params.sc_apikey = ApiConstant.isProduction ? ApiConstant.sitecoreApiKey : ApiConstant.sitecoreApiKeyLocal;

  if (!ApiConstant.isProduction) {
    params.withCredentials = true;
  }

  const response = await axios.get(`${endpoint}`, params);
  return response.data;
}

export async function HttpPost(endpoint = '', body = {}, params: HttpParams = {}, contentType: string = 'application/json') {
  try {
    params.params = {};
    params.headers = new AxiosHeaders().setContentType(contentType);
    params.params.sc_apikey = ApiConstant.isProduction ? ApiConstant.sitecoreApiKey : ApiConstant.sitecoreApiKeyLocal;

    if (!ApiConstant.isProduction) {
      params.withCredentials = true;
    }

    const response = await axios.post(`${endpoint}`, body, params);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function HttpPut(endpoint = '', body = {}, params: HttpParams = {}) {
  try {
    params.params = {};
    params.params.sc_apikey = ApiConstant.isProduction ? ApiConstant.sitecoreApiKey : ApiConstant.sitecoreApiKeyLocal;
    if (!ApiConstant.isProduction) params.withCredentials = true;
    const response = await axios.put(`${endpoint}`, body, params);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
